"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyExchangeObjectTypeEnumArray = exports.CurrencyExchangeObjectType = void 0;
var CurrencyExchangeObjectType;
(function (CurrencyExchangeObjectType) {
    CurrencyExchangeObjectType["ROOT"] = "ROOT";
    CurrencyExchangeObjectType["RECORD"] = "RECORD";
})(CurrencyExchangeObjectType || (exports.CurrencyExchangeObjectType = CurrencyExchangeObjectType = {}));
exports.currencyExchangeObjectTypeEnumArray = Object.values(CurrencyExchangeObjectType);
